import React, { forwardRef, memo, useMemo } from 'react';
import { SvgIcon } from '@material-ui/core';

import { generateSvgId } from 'src/lib/svg';

export const IconColdEmail = memo(
  forwardRef((props, ref) => {
    const svgId = useMemo(() => generateSvgId(), []);

    return (
      <SvgIcon {...props} ref={ref} viewBox="0 0 30 30" data-fill-none>
        <g clipPath={`url(#${svgId})`}>
          <path
            d="M6.6875 12.5V6.54364C6.6875 6.24339 7.06422 5.99999 7.52893 6L21.0279 6.00041C21.4925 6.00042 21.8692 6.24382 21.8692 6.54406V12.5"
            stroke="#28354D"
          />
          <path
            d="M15.5 22.18H5.84244C5.37721 22.18 5.00008 21.7907 5.00008 21.3106L5 12.9303C4.99998 12.2574 5.70885 11.8396 6.27041 12.1814L13.898 16.8252C14.1633 16.9867 14.4929 16.986 14.7576 16.8231L22.2814 12.1927C22.843 11.8473 23.5553 12.2647 23.5553 12.9394V15.999"
            stroke="#28354D"
          />
          <rect
            x="8.375"
            y="8"
            width="11.808"
            height="1.06031"
            rx="0.530156"
            fill="#28354D"
          />
          <rect
            x="8.375"
            y="10.5332"
            width="5.90401"
            height="1.06031"
            rx="0.530156"
            fill="#28354D"
          />
          <circle cx="21" cy="21" r="4" stroke="#FF9D28" strokeWidth="0.7" />
          <path
            d="M19.4023 21.2398L20.3623 22.1998L22.7623 19.7998"
            stroke="#FF9D28"
            strokeWidth="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id={svgId}>
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(3 3)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
